export const routes = {
  home: '/',
  reciters: '/reciter',
  featuredReciters: '/featured-reciters',
  bookmarks: '/bookmarks',
  surah: '/surah',
  surahRead: '/surah/read',
  surahReadHistory: '/surah/read/[suraSlug]/history',
  reciterSurah: '/reciter/[reciterSlug]/surah/[surahSlug]',
  duaa: '/duaa',
  ruqia: '/ruqia',
  mostPopular: '/most-popular',
  myFavorite: '/my-favorite',
  ourApps: '/our-apps',
  loginAPIEndpoint: '/api/login',
  logoutAPIEndpoint: '/api/logout',
  playlist: '/playlist',
  profile: '/profile',
  search: '/search',
  aboutUs: '/about-us',
  support: '/support',
  blog: '/blog',
};

export const authorizedRoutes = [routes.myFavorite];
